<template>
  <div class="row">
    <h4>Dodawanie leada do procesu wypłat</h4>

    <form-searcher label="SALESFORCE ID" v-model="search" @submitAction="buttonProcessLead()"
              buttonIcon="mfind-icon-send" dataTooltip="Wypłać środki dla beneficjenta"/>

    <transition name="slide-fade">
      <div class="response" v-if="responseMessage">
        <h5>{{ responseMessage }}</h5>
      </div>
    </transition>

    <Loader :loading="loading" type=""/>
  </div>
</template>

<script>
import Loader from '@/components/loader'
import FormSearcher from '@/components/forms/searcher'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('tranches')
export default {
  components: { Loader, FormSearcher },
  data () {
    return {
      search: '',
      loading: false,
      responseMessage: ''
    }
  },
  methods: {
    buttonProcessLead () {
      this.responseMessage = ''
      if (this.search) {
        this.processLead()
      } else {
        this.responseMessage = 'Najpierw wprowadź SALESFORCE ID'
      }
    },
    processLead () {
      this.showLoader()
      this.responseMessage = ''
      this.$store.dispatch('processLead', this.search)
      .then(
        response => {
          if (response.code === 200) {
            this.responseMessage = response.data.message
            this.hideLoader()
            this.clearSearch()
          }
        },
        errorResponse => {
          this.responseMessage = errorResponse.errors.message +
            '\nW razie powtarzających się problemów skontaktuj się z działem IT'
          this.hideLoader()
        }
      )
    },
    showLoader () {
      this.loading = true
    },
    hideLoader () {
      this.loading = false
    },
    clearSearch () {
      this.search = ''
    }
  },
  computed: {
    // mix the getters into the computed object
    ...mapGetters([ ])
  }
}
</script>

<style lang="scss">
.send-email-form {
  .input-field label {
    margin-top: 0;
  }
  .btn-search {
    position: absolute;
    top: 0%;
    right: 0%;
    height: 3.5em;
    width: 3.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 7%;
  }
}

.response h5{
  white-space: pre-wrap;
  font-size: 18pt;
}
</style>



// WEBPACK FOOTER //
// completeProcess.vue?c7c9e704